module.exports = __webpack_public_path__ + "img/03.6227fb6d.jpg";